<template>
	<div class="body">
		<div class="body-container" v-if="data">

			<div class="title-ctr">{{data.title}}</div>

			<div class="step-ctr">
				<div class="step-name">{{data.step}}</div>
				
				<div class="step-route" @click="clickRule(data.ruleRoute)">{{data.ruleRoute.title}}</div>
			</div>


			<!-- 	<div class="intro-ctr">
				<div class="intro-name">{{data.tableRoute.title}}</div>

				<div class="intro-route" @click="clickRule(data.tableRoute)">{{data.tableRoute.name}}</div>
			</div> -->

			<div class="factor-ctr">
				<label class="factor-name">{{data.capacityData.title}}</label>

				<el-input class="factor-input" v-model="capactiyFactor" @input="capacityChange" type="number"
					:step="capacityStep"></el-input>

				<label class="factor-note">调整区间：{{data.capacityData.min}}-{{data.capacityData.max}}</label>
			</div>

			<div class="factor-ctr factor-ctr-last">
				<label class="factor-name">{{data.effectData.title}}</label>

				<el-input class="factor-input" v-model="effectFactor" @input="effectChange" type="number"
					:step="step"></el-input>

				<label class="factor-note">调整区间：{{data.effectData.min}}-{{data.effectData.max}}</label>
			</div>

			<el-table :data="list" border stripe>
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="基准用工人数" align="center" prop="employee_num" />
				<el-table-column label="双维校准用工人数" align="center" prop="employee_num_f" />
			</el-table>
		</div>

		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下一步</el-button>
		</div>

		<el-dialog title="原理介绍" :visible.sync="showIntroDialog" append-to-body v-if="showIntroDialog" align="center">

			<div class="rich-ctr">
				<div class="rich-value" v-html="introDialog.value"></div>
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIntroDialog()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getMatchFactorPage,
		factorChange
	} from "@/api/service"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				capactiyFactor: '',
				effectFactor: '',
				data: null,
				list: null,
				step: 0.001,
				capacityStep: 0.000001,
				showIntroDialog: false,
				introDialog: null,
				variableType: {
					File: 2,
					Rich: 3
				}
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},

			buildParams() {
				this.params['capacity'] = this.capactiyFactor;
				this.params['effect'] = this.effectFactor;
				return this.params;
			},

			requestData() {
				getMatchFactorPage(this.buildParams()).then(res => {
					let realData = res.data;
					this.capactiyFactor = realData.capacityData.value;
					this.effectFactor = realData.effectData.value;
					this.data = realData;
					this.list = realData.list;
				});
			},

			clickNext() {
				let path = '/expand?id=' + this.params['id']
				this.$router.push(path);
			},


			clickRule(route) {
				if (route.type == this.variableType.File) {
					let path = route.path;
					window.open(path, '_blank')
				} else if (route.type == this.variableType.Rich) {
					this.showIntroDialog = true;
					this.introDialog = route;
				}
			},

			clickCloseIntroDialog() {
				this.showIntroDialog = false;
			},
			
			effectChange(num) {
				console.log(num)
				// 最小值限制
				if (num < this.data.effectData.min) {
					num = this.data.effectData.min;
				}

				// 最大值限制
				if (num > this.data.effectData.max) {
					num = this.data.effectData.max;
				}

				// 保留小数位数（可选）
				this.effectFactor = num

				this.onFactorChange();
			},

			capacityChange(num) {
				console.log(num)
				// 最小值限制
				if (num < this.data.capacityData.min) {
					num = this.data.capacityData.min;
				}

				// 最大值限制
				if (num > this.data.capacityData.max) {
					num = this.data.capacityData.max;
				}

				// 保留小数位数（可选）
				this.capactiyFactor = num

				this.onFactorChange();
			},

			onFactorChange() {
				factorChange(this.buildParams()).then(res => {
					this.list = res.data.list;
				})
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "factor.scss";
</style>